import { Container } from 'pixi.js';

export interface ScreenContext {
  width: number;   // current logical container size (square)
  height: number;
  switch(to: ScreenFactory): void;
}

export interface Screen {
  container: Container;
  enter(ctx: ScreenContext): Promise<void> | void;
  exit(): Promise<void> | void;
  resize(width: number, height: number): void;
  update?(dtSec: number, nowMs: number): void;
}

export type ScreenFactory = () => Screen;

export class ScreenManager {
  private current: Screen | null = null;
  private root: Container;
  private size = { w: 0, h: 0 };

  constructor(root: Container) {
    this.root = root;
  }

  setSize(w: number, h: number) {
    this.size.w = w; this.size.h = h;
    if (this.current) this.current.resize(w, h);
  }

  async switch(to: ScreenFactory) {
    if (this.current) {
      await this.current.exit();
      this.root.removeChild(this.current.container);
      this.current.container.destroy({ children: true });
    }
    const next = to();
    this.root.addChild(next.container);
    next.resize(this.size.w, this.size.h);
    await next.enter({
      width: this.size.w,
      height: this.size.h,
      switch: (f) => { void this.switch(f); },
    });
    this.current = next;
  }

  update(dtSec: number, nowMs: number) {
    this.current?.update?.(dtSec, nowMs);
  }
}
